<script>
  import { onMount } from "svelte"

  export let placement
  export let currentpage
  export let pdfDimensions = {}
  export let signSource

  let imageAspectRatio = 0

  let isDragging = false

  let hideSign = false

  let resizeItems = ["top-left", "top-right", "bottom-left", "bottom-right"]

  let signImgWidth
  let signImgHeight

  let MINIMUM_HEIGHT
  let activeResizer = null
  let signElement

  onMount(async () => {
    MINIMUM_HEIGHT = signImgHeight = (pdfDimensions.clientHeight / pdfDimensions.height) * 72
  })

  const assignCoordinate = () => {
    try {
      if (!signElement || hideSign) return

      // let parentElement = signElement.parentElement
      // if (!parentElement) return

      const { x, y } = getPosition()

      let yRatio = pdfDimensions.height / pdfDimensions.clientHeight
      let xRatio = pdfDimensions.width / pdfDimensions.clientWidth

      let x1 = x * xRatio
      let y1 = Math.abs((pdfDimensions.clientHeight - y - signElement.offsetHeight) * yRatio).toFixed(2)
      let x2 = (x + signElement.offsetWidth) * xRatio
      let y2 = (pdfDimensions.clientHeight - y) * yRatio
      // let x1 = Math.floor(x * xRatio)
      // let y1 = Math.floor((parentElement.clientHeight - y - signElement.clientHeight) * yRatio)
      // let x2 = Math.floor((x + signElement.clientWidth) * xRatio)
      // let y2 = Math.floor((parentElement.clientHeight - y) * yRatio)
      placement.coordinate = `${x1}, ${y1}, ${x2}, ${y2}`

      console.log("coordinate sign", placement.coordinate)
    } catch (error) {
      console.error(error)
      const info = "PAGE: Docket Creation\nEVENT: Error occured during coordinate assignment"
      notify.danger(error, info)
    }
  }

  const getPosition = () => {
    try {
      let parentElement = signElement.parentElement
      // console.log(signElement, parentElement)
      let offsetX = signElement.getBoundingClientRect().left - parentElement.getBoundingClientRect().left
      let offsetY = signElement.getBoundingClientRect().top - parentElement.getBoundingClientRect().top

      if (offsetX < 0) offsetX = 0
      if (offsetY < 0) offsetY = 0

      return { x: offsetX, y: offsetY }
    } catch (error) {
      console.error(error)
      const info = "PAGE: Docket Creation\nEVENT: Error occured during coordinate calculation"
      notify.danger(error, info)
    }
  }

  $: checkMultiPage(placement, currentpage)

  const checkMultiPage = (placement, currentpage) => {
    if (currentpage == 0) hideSign = true
    if (!currentpage && currentpage == 0) return

    if (placement.pages == "ALL") hideSign = false
    else if (placement.pages == "ODD") hideSign = currentpage % 2 == 0
    else if (placement.pages == "EVEN") hideSign = currentpage % 2 != 0
    else hideSign = placement.pages != currentpage - 1
  }

  $: onPdfPageSizeChange(placement.coordinate, pdfDimensions.clientHeight, pdfDimensions.clientWidth)

  const onPdfPageSizeChange = () => {
    try {
      if (!placement.coordinate) return
      applyCoordinate()
      // if (placement.pages == "ODD" || placement.pages == "EVEN" || placement.pages == "ALL") applyCoordinate()
    } catch (error) {
      console.error(error)
    }
  }

  const applyCoordinate = () => {
    try {
      // console.log(pdfDimensions, "sizeChange")

      // Parse the coordinates for the signature
      let [x1, y1, x2, y2] = placement.coordinate.split(",").map(Number)

      let yRatio = pdfDimensions.height / pdfDimensions.clientHeight
      let xRatio = pdfDimensions.width / pdfDimensions.clientWidth

      signImgWidth = Math.abs(x2 - x1) / xRatio
      signImgHeight = Math.abs(y2 - y1) / yRatio

      let x = x1 / xRatio
      let y = pdfDimensions.clientHeight - signImgHeight - y1 / yRatio

      // console.log(x, signImgWidth, pdfDimensions.clientWidth, x + signImgWidth)
      const leftPosition = x + signImgWidth > pdfDimensions.clientWidth ? pdfDimensions.clientWidth - signImgWidth : x
      // console.log({ leftPosition })

      signElement.style.left = leftPosition + "px"
      signElement.style.top = y < 0 ? 0 : y + "px"
    } catch (error) {
      console.error(error)
    }
  }

  const signDetails = {
    width: "",
    height: "",
    mousePosition: {
      x: "",
      y: "",
    },
    position: {
      x: "",
      y: "",
    },
  }

  const mouseDown = (e, resizer) => {
    isDragging = true
    activeResizer = resizer

    // Store initial position and dimensions
    const { x, y } = getPosition()

    // console.log(signImgHeight, signElement.clientHeight)

    signDetails.width = parseFloat(getComputedStyle(signElement).width)
    signDetails.height = parseFloat(getComputedStyle(signElement).height)
    signDetails.mousePosition.x = e.pageX
    signDetails.mousePosition.y = e.pageY
    signDetails.position.x = x
    signDetails.position.y = y

    window.addEventListener("mouseup", mouseUp)
    window.addEventListener("mousemove", mouseMove)
  }

  /**
   * @param {MouseEvent}  event
   */
  const mouseMove = (e) => {
    if (!isDragging || !activeResizer) return

    const deltaX = e.pageX - signDetails.mousePosition.x
    const deltaY = e.pageY - signDetails.mousePosition.y

    let width = signDetails.width
    let height = signDetails.height
    let newLeft = signDetails.position.x
    let newTop = signDetails.position.y

    if (activeResizer.includes("bottom-right")) {
      width += deltaX
      height = width / imageAspectRatio
    } else if (activeResizer.includes("bottom-left")) {
      width -= deltaX
      height = width / imageAspectRatio
      newLeft += deltaX
    } else if (activeResizer.includes("top-right")) {
      height -= deltaY
      width = height * imageAspectRatio
      newTop += deltaY
    } else {
      height -= deltaY
      width = height * imageAspectRatio
      newLeft += signDetails.width - width
      newTop += signDetails.height - height
    }

    const parent = signElement.parentElement
    let parentWidth = parseFloat(getComputedStyle(parent).width)
    let parentHeight = parseFloat(getComputedStyle(parent).height)

    if (height >= MINIMUM_HEIGHT && newLeft >= 0 && newTop >= 0 && newLeft + width <= parentWidth && newTop + height <= parentHeight) {
      signImgWidth = width
      signImgHeight = height
      if (activeResizer.includes("left")) signElement.style.left = `${newLeft}px`
      if (activeResizer.includes("top")) signElement.style.top = `${newTop}px`
    }
  }

  const mouseUp = () => {
    if (isDragging || activeResizer) assignCoordinate()
    isDragging = false
    activeResizer = null
  }

  const handleImageLoad = (e) => {
    let naturalWidth = e.target.naturalWidth
    let naturalHeight = e.target.naturalHeight

    imageAspectRatio = naturalWidth / naturalHeight
    signImgWidth = imageAspectRatio * signImgHeight

    // console.log({ imageAspectRatio, signImgWidth })

    if (!placement.coordinate) {
      let parentWidth = parseFloat(getComputedStyle(signElement.parentElement).width)
      let parentHeight = parseFloat(getComputedStyle(signElement.parentElement).height)
      signElement.style.left = (parentWidth - signImgWidth) / 2 + "px"
      signElement.style.bottom = (parentHeight - signImgHeight) / 2 + "px"

      setTimeout(() => {
        assignCoordinate()
      }, 100)
    }
  }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div bind:this={signElement} on:mousedown on:mouseup style="height:{signImgHeight}px;width:{signImgWidth}px;" class="bottom-[45%] left-[35%] cursor-all-scroll border-2 border-red-500 bg-cover bg-center bg-no-repeat text-[0.6em] font-bold {hideSign ? 'hidden' : 'block'} absolute select-none">
  <img on:load={handleImageLoad} src={signSource} alt="signPlacement" class="pointer-events-none h-full w-full select-none" />
  {#each resizeItems as item}
    <div
      on:mousedown|preventDefault|stopPropagation={(e) => {
        mouseDown(e, item)
      }}
      class="absolute {item} pointer-events-auto select-auto rounded-full hover:scale-125"
    >
      <svg width="6" height="6">
        <circle cx="3" cy="3" r="3" fill="#ef4444" />
      </svg>
    </div>
  {/each}
</div>

<style lang="postcss">
  .resizers {
    @apply box-border h-full w-full border-[3px] border-red-500;
  }
  .resizer {
    @apply absolute z-10 h-3 w-3 border-[3px] border-red-500 bg-white;
  }
  .top-left {
    @apply left-0 top-0 -translate-y-1/2 -translate-x-1/2 cursor-nwse-resize;
  }
  .top-right {
    @apply right-0 top-0 -translate-y-1/2 translate-x-1/2 cursor-nesw-resize;
  }
  .bottom-left {
    @apply left-0 bottom-0 translate-y-1/2 -translate-x-1/2 cursor-nesw-resize;
  }
  .bottom-right {
    @apply right-0 bottom-0 translate-y-1/2 translate-x-1/2 cursor-nwse-resize;
  }
  .top-center {
    @apply left-1/2 -top-[5px] -translate-x-1/2 cursor-ns-resize;
  }
  .bottom-center {
    @apply left-1/2 -bottom-[5px] -translate-x-1/2 cursor-ns-resize;
  }
  .left-center {
    @apply top-1/2 -left-[5px] -translate-y-1/2 cursor-ew-resize;
  }
  .right-center {
    @apply top-1/2 -right-[5px] -translate-y-1/2 cursor-ew-resize;
  }
</style>
